import React, { useEffect } from 'react'
import {
  FormHelperText,
  TextField,
} from '@mui/material'
import { useInput } from 'react-admin'

export const TextInput = ({
    source,
    value,
    defaultValue,
    validate,
    onChange,
    helperText,
    ...props
  }) => {
  const { field, fieldState } = useInput({source, validate, defaultValue: defaultValue || ''})
  const { error } = fieldState

  useEffect(() => {
    // Si no se pasa `value`, NO pisar el valor proveniente del record/form.
    if (value === undefined) return

    field.onChange(value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const onChangeField = (e) => {
    field.onChange(e.target.value)
    onChange && onChange(e)
  }

  return (
    <>
      <TextField
        {...props}
        fullWidth
        size='small'
        value={field.value}
        onChange={onChangeField}
        error={error?.message ? true : false}
      />

      <FormHelperText className='form-helper-text' error={error?.message ? true : false}>
        {error?.message || helperText}
      </FormHelperText>
    </>
  )
}
